import { Reducer } from "redux";

import { UpdateStartOfCareDateApiResponse } from "../models/api/Referral";
import { UpdateStartOfCareDateDispatchTypes } from "../models/dispatchTypes/Referral";
import { UpdateStartOfCareDateActionDispatchTypes } from "../constants/Referral";

const initialState: UpdateStartOfCareDateApiResponse = {
  loading: false,
  response: {
    updatedStartOfCareDate: "",
    minEffectiveFromDate: "",
    maxEffectiveThroughDate: "",
  },
  error: null,
};

const UpdateStartOfCareDateReducer: Reducer<
  UpdateStartOfCareDateApiResponse,
  UpdateStartOfCareDateDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case UpdateStartOfCareDateActionDispatchTypes.UPDATE_START_OF_CARE_DATE_INVOKE: {
      return {
        ...state,
        error: null,
        loading: true,
      };
    }
    case UpdateStartOfCareDateActionDispatchTypes.UPDATE_START_OF_CARE_DATE_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case UpdateStartOfCareDateActionDispatchTypes.UPDATE_START_OF_CARE_DATE_ERROR: {
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    }
    case UpdateStartOfCareDateActionDispatchTypes.UPDATE_START_OF_CARE_DATE_RESET: {
      return initialState;
    }
  }
  return state;
};

export default UpdateStartOfCareDateReducer;
